import React from 'react';

const RetailShopping = ({ register }) => {
  const numberOfRevenueCenters = [0, 1, 2, 3, 4, 5];

  return (
    <div className="col-md-8">
      <div className="row col-md-offset-1">
        <label>Ordering Type:</label>
        <br />
        <div className="row col-md-offset-1">
          <input
            id="email_ordering"
            type="checkbox"
            {...register('products.ird.settings.available_ordering_modes.email')}
          />
          <label htmlFor="email_ordering" className="col-md-column-18">
            Email
          </label>
          <br />
          <input
            id="read_only"
            type="checkbox"
            {...register('products.ird.settings.available_ordering_modes.read_only')}
          />
          <label htmlFor="read_only" className="col-md-column-18">
            Read-only
          </label>
          <br />
          <div>
            <input
              id="on_site"
              type="checkbox"
              {...register('products.ird.settings.available_ordering_modes.on_site')}
            />
            <label htmlFor="on_site" className="col-md-column-18">
              On-site Fulfillment
            </label>
            <br />
          </div>
        </div>
      </div>
      <br />

      <div className="row col-md-offset-1">
        <label>Number of Revenue Centers:</label>
        <div className="row col-md-offset-1">
          <select
            className="rc-num-chan form-control"
            {...register('products.ird.settings.number_of_revenue_centers', {
              value: 1,
              valueAsNumber: true,
            })}
          >
            {numberOfRevenueCenters.map((n, i) => (
              <option value={n} key={`center${i}`}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>
      <br />

      <div className="row col-md-offset-1">
        <em className="help-block">
          Reminder: The above configuration may affect the Settings for this
          service. Make sure to review the Settings tab before publishing.
        </em>
      </div>
    </div>
  );
};

export default RetailShopping;
